
import { defineComponent, ref, watch, onMounted, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import DialogComponent from '@/components/Dialog.vue'

import Moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    name: 'App',
    components: {
        DialogComponent,
    },
    computed: {
        ...mapState(['activityData', 'dialogData', 'popData', 'picViewerData'])
    },
    setup (props, context) {
        const $store = useStore()
        const router = useRouter()
        const _this = getCurrentInstance() as any
        const isApp = ref<boolean>(false)

        const getActDetail = () => {
            _this.proxy.$request('/activity/config', {
                aid: $store.state.aid
            }).then((data: any) => {
                document.title = data.title
                // 设置分享信息
                data.share && setShareData(data) 
                $store.commit('SET_ACTIVITYDATA', data)
                // 判断活动状态
                activityStatus(data)
            })
        }

        const activityStatus = (data: any) => {
            if (new Date(data.serverTime).getTime() < new Date(data.startTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: `活动尚未开启，请在${Moment(data.startTime).format('YYYY.MM.DD')}-${Moment(data.endTime).format('YYYY.MM.DD')}时间段内来参与！`
                })
            } else if (new Date(data.serverTime).getTime() > new Date(data.endTime).getTime()) {
                $store.commit('SET_DIALOGDATA', {
                    text: '您来晚了，本活动已经结束！'
                })
            } else if (!isApp.value && data.isAppShow) {
                $store.commit('SET_DIALOGDATA', {
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
            }
        }

        const setShareData = (data: any) => {
            $store.commit('SET_SHAREDATA', {
                title: data.share.title,
                desc: data.share.desc,
                imgUrl: data.share.imgUrl || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                link: data.share.link || window.location.origin + window.location.pathname
            })
        }

        watch(() => router.currentRoute.value, (to, from) => {
            if (to.fullPath != from.fullPath) {
                $store.commit('SET_DIALOGDATA', null)
                _this.proxy.$common.pageLoading()
                document.documentElement.scrollTop = 0
            }
        })

        getActDetail()

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            window.addEventListener('pageshow', (e) => {
                if (e.persisted) {
                    window.location.reload()
                }
            })
        })
    }
})

